function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var KiribatiFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#E31D1C",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#FFC84A",
        fillRule: "evenodd",
        d: "m11.492 15.883.344-.745.343.745.204-.794.472.672.058-.817.585.578-.09-.814.68.464-.236-.784.752.336-.372-.73.8.198-.498-.653.824.053-.608-.554.82-.094-.697-.437.79-.238-.766-.307.735-.373-.809-.167.656-.497-.825-.02.555-.607-.816.126.438-.694-.78.268.305-.76-.719.402.163-.803-.635.523.017-.818-.53.627-.132-.809-.41.711-.274-.772-.275.772-.41-.71-.13.808-.531-.627.016.818-.635-.523.164.803-.72-.402.306.76-.78-.268.437.694-.815-.126.555.606-.825.02.655.498-.808.167.735.373-.766.307.79.238-.698.437.82.094-.607.554.823-.053-.498.653.801-.198-.373.73.753-.336-.236.784.68-.464-.09.814.585-.578.058.817.472-.672.204.794Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "m-.594 13.44 2.11-.856a.78.78 0 0 1 .594.002l3.032 1.262c.206.086.438.08.638-.016l2.52-1.21c.21-.1.454-.102.666-.005l2.63 1.215a.781.781 0 0 0 .652.002l2.68-1.222a.781.781 0 0 1 .651.001l2.647 1.222a.78.78 0 0 0 .643.006l2.843-1.252a.78.78 0 0 1 .579-.02l2.424.871v7.51H-.661l.067-7.51Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "26",
        height: "9",
        x: "-1",
        y: "12",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m-.594 13.44 2.11-.856a.78.78 0 0 1 .594.002l3.032 1.262c.206.086.438.08.638-.016l2.52-1.21c.21-.1.454-.102.666-.005l2.63 1.215a.781.781 0 0 0 .652.002l2.68-1.222a.781.781 0 0 1 .651.001l2.647 1.222a.78.78 0 0 0 .643.006l2.843-1.252a.78.78 0 0 1 .579-.02l2.424.871v7.51H-.661l.067-7.51Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          stroke: "#015989",
          d: "m-.594 15.184 2.11-.856a.78.78 0 0 1 .594.003l3.032 1.262c.206.085.438.079.638-.017l2.52-1.21c.21-.1.454-.102.666-.004l2.63 1.215a.781.781 0 0 0 .652.001l2.68-1.222a.781.781 0 0 1 .651.002l2.647 1.221a.78.78 0 0 0 .642.006l2.844-1.252a.78.78 0 0 1 .579-.02l2.424.871M-.594 17.681l2.11-.856a.78.78 0 0 1 .594.002l3.032 1.262a.78.78 0 0 0 .638-.016l2.52-1.21c.21-.1.454-.102.666-.005l2.63 1.215a.78.78 0 0 0 .652.002l2.68-1.222a.781.781 0 0 1 .651.001l2.647 1.222a.78.78 0 0 0 .642.006l2.844-1.252a.78.78 0 0 1 .579-.02l2.424.871"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#015989",
          fillRule: "evenodd",
          d: "m-.594 19.67 1.348-.547a2.781 2.781 0 0 1 2.114.01l2.274.946c.206.085.438.08.638-.017l1.671-.802a2.781 2.781 0 0 1 2.37-.017l1.775.82a.781.781 0 0 0 .652.002l1.845-.842a2.78 2.78 0 0 1 2.32.005l1.813.838a.78.78 0 0 0 .642.005l2.113-.93a2.781 2.781 0 0 1 2.062-.072l1.672.602v2.486H-.456l-.138-2.486Z",
          clipRule: "evenodd"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFC84A",
        fillRule: "evenodd",
        d: "M7.201 4.799s1.069.213 1.42.213 1.144-.537 1.603-.358c.458.18 1.34 1.026 1.34 1.026s1.25-.937 2.01-.937c.76 0 2.156.102 2.156.102s-.321.835-1.226.977c-.905.141-1.988.834-1.988.834h1.471c.224 0 .966.415.966.415s-1.053.333-1.354.333h-.634s-.64.55-1.432.433c-.792-.117-1.345-.625-1.345-.625S9.07 7.14 9.07 7.02c0 0-.427-.218-.555 0-.129.219.555-.292.555-.292s.617-.502.826-.502c.21 0 .908.43.908.43l.167-.173-.866-.66c-1.765.184-2.905-1.023-2.905-1.023Z",
        clipRule: "evenodd"
      })]
    })]
  })]
}));
//# sourceMappingURL=Kiribati.js.map